import {
  EFeatureFlags,
  useFeatureFlag
} from 'astra-core/containers/ConfigProvider'

import { FeatureFlagsType } from './types'

export const useAppFeatureFlag = (flag: FeatureFlagsType): boolean => {
  return useFeatureFlag(flag as EFeatureFlags)
}
